import { stringify } from 'query-string';
import { MAX_LIMIT } from 'config';

import { sortOrderTypes } from 'types/shared';

const baseURL = '/api/social/platforms';

interface ISocialPlatformsURLArgs {
  entityIds?: string[];
  platformFilter?: string;
  source?: string;
  sortBy?: string;
  sortOrder?: sortOrderTypes;
  offset?: number;
  limit?: number;
}

export default function getSocialPlatformsURL(
  args: ISocialPlatformsURLArgs = {}
): string {
  if (!args) return baseURL;

  const {
    entityIds,
    platformFilter,
    source,
    sortBy,
    sortOrder,
    offset,
    limit = MAX_LIMIT,
  } = args;

  const params = stringify({
    platformFilter,
    source,
    sortBy,
    sortOrder,
    offset,
    limit,
  });

  if (!entityIds) {
    return `${baseURL}?${params}`;
  }

  return `${baseURL}/artist/${entityIds}?${params}`;
}
